import AuditEdit from '@/components/audit/edit/AuditEdit.vue';
import AuditEditConfig from '@/components/audit/editconfig/AuditEditConfig.vue';
import AuditReportGenerator from '@/components/audit/reportgenerator/AuditReportGenerator.vue';

const defaultFilterValues = {
  clientName: '',
  date: null,
  fixUntil: null,
  manager: null,
  materialGroups: [],
  status: null
}

export default {
  name: 'AuditList',
  props: {
    client: {
      default: null,
      type: Object
    }
  },
  components: {
    AuditEdit,
    AuditEditConfig,
    AuditReportGenerator
  },
  data () {
    return {
      isMounted: false,
      loading: true,
      currentReq: null,
      tableData: [],
      auditConfigs: null,
      filterValues: this.BasicHelper.cloneObject(defaultFilterValues),
      paging: {
        perPage: 10,
        currentPage: 1,
        rowCount: 0,
        pageCount: 0
      }
    }
  },
  computed: {
    canEdit () {
      return this.ApiRequest.userHasPermission('edit-clients');
    },
    filterActions () {
      const actions = { filters: true, reload: true, extra: [] };
      actions.extra.push({
        class: 'btn-download', event: 'generateAuditPdf', icon: 'file-bar-graph-fill', title: this.$t('audit.generate-pdf.btn-title')
      });
      if (this.canEdit) {
        actions.add = { title: this.$t('menu.audit.new') }
      }
      return actions;
    },
    auditStatusOptions () {
      const options = this.$store.getters.getConfigOptions('client_audit_statuses', this.$i18n.locale);
      options.unshift({ text: '', id: null });
      return options;
    },
    managerOptions () {
      const options = this.$store.getters.getConfigOptions('managers');
      options.unshift({ text: '', id: null });
      return options;
    },
    materialGroupOptions () {
      return this.$store.getters.getConfigOptions('material_groups', this.$i18n.locale, 'disabled', 0);
    },
    tableExpandConfig () {
      return { component: 'AuditListExpand' };
    },
    tableFilterConfig () {
      const filters = {
        materialGroups: { type: 'checkbox', label: this.$t('material-group.title'), options: this.materialGroupOptions, colOnlyFilter: true },
        date: { type: 'date', label: this.$t('general.filters.date'), colOnlyFilter: true },
        fixUntil: { type: 'date', label: this.$t('general.filters.date'), colOnlyFilter: true },
        manager: { type: 'select', label: this.$t('client.manager'), options: this.managerOptions, colOnlyFilter: true },
        status: { type: 'select', label: this.$t('audit.status'), options: this.auditStatusOptions, colOnlyFilter: true }
      };
      if (!this.client) {
        filters.clientName = { type: 'text', label: this.$t('client.name'), colOnlyFilter: true };
      }
      return filters;
    },
    tableHeaders () {
      const actions = [{ label: this.$t('menu.audit.edit'), emit: 'editAudit', icon: 'edit', bicon: 'pencil-fill' }];
      const headerConf = [
        { key: 'date', label: this.$t('audit.date'), type: 'date', filterKey: 'date' },
        { key: 'material_group_id', label: this.$t('material-group.title'), format: 'formatFromConfig', configKey: 'material_groups', configParam: 'name', filterKey: 'materialGroups' },
        { key: 'status_id', label: this.$t('audit.status'), format: 'formatFromConfig', configKey: 'client_audit_statuses', configParam: 'name', filterKey: 'status' },
        { key: 'user.name', label: this.$t('audit.done_by_user'), filterKey: 'manager' },
        { key: 'fixUntil', label: this.$t('audit.fixUntil'), type: 'date', filterKey: 'fixUntil' },
        { key: 'actions', label: '', actions: actions }
      ];
      if (!this.client) {
        headerConf.unshift({ key: 'client.name', label: this.$t('client.name'), filterKey: 'clientName' });
      }
      return headerConf;
    }
  },
  methods: {
    getRequestPath () {
      let path = 'audit/list?perPage=' + this.paging.perPage + '&page=' + this.paging.currentPage;
      let filterVals = this.filterValues;
      if (this.$refs.tableview) {
        filterVals = this.$refs.tableview.getFilterValues();
      }
      this.BasicHelper.updateFilterValues(this.$route.name, filterVals);
      path = this.ApiRequest.addGetParamsToPath(path, filterVals, true);
      if (this.client) {
        path += '&client=' + this.client.api_id;
      }
      return path;
    },
    getTableData () {
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      const self = this;
      this.loading = true;
      this.currentReq = this.ApiRequest.request(this.getRequestPath(), this.ApiRequest.REQUEST_GET, [], function (response) {
        if (response.data) {
          self.tableData = response.data.audits;
          if (response.data.configs) {
            self.auditConfigs = response.data.configs;
          }
          self.loading = false;
        }
        if (response.paging) {
          self.paging.rowCount = response.paging.total;
          self.paging.currentPage = response.paging.page;
          self.paging.pageCount = response.paging.pages;
        } else {
          self.paging.pageCount = 0;
        }
      });
    },
    generateAuditPdf () {
      this.$refs.auditGenerateFrm.show();
    },
    changePage (pageNr) {
      this.currentPage = pageNr;
      this.getTableData();
    },
    reloadTable () {
      this.BasicHelper.updateFilterValues(this.$route.name, this.filterValues);
      this.getTableData();
    },
    clearFilters () {
      this.filterValues = this.BasicHelper.cloneObject(defaultFilterValues);
      this.reloadTable();
    },
    getAuditCardClass (matGroup) {
      if (matGroup && this.auditConfigs[matGroup.value] && this.auditConfigs[matGroup.value].hasActiveContract) {
        return 'active';
      }
      return 'inactive';
    },
    editAudit (el) {
      this.$refs.auditEditFrm.show(el, this.client);
    },
    editAuditConf (matGroupId) {
      let el = null;
      if (this.auditConfigs && this.auditConfigs[matGroupId]) {
        el = this.auditConfigs[matGroupId];
        el.client = this.client;
      }
      this.$refs.auditEditConfigFrm.show(el, matGroupId, this.client);
    },
    itemEdited () {
      this.$emit('updated');
      this.reloadTable();
    }
  },
  mounted () {
    this.filterValues = this.BasicHelper.fillFilterValues(this.$route.name, this.filterValues, this.$session);
    if (this.client) {
      this.filterValues.clientName = '';
    }
    this.isMounted = true;
  }
}
